import React from "react";

export default function ArbUniverse() {
  return (
    <div>
      <h1>Arb Universe page is under construction</h1>
    </div>
  );
}
